export default {
  init() {
    $(function() {
        $(document.body).on('updated_cart_totals', function() {
            $('.cart-contents-count').html($('.order-total bdi').html());
        });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js